export default __webpack_public_path__ + "static/media/01_Kom_FGO.53828185.png";